import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { fetchGroupById } from "../../../redux/group/groupSlice";
import { ReactComponent as EditIcon } from "../../../assets/svgs/editButton.svg";
import EditDetailForm from "../DailogBoxes/EditDetailForm";
import PopupCard from "../../../components/Cards/PopupCard/PopupCard";
import { ReactComponent as BackIcon } from "../../../assets/svgs/back-button.svg";
// import TextStyles from "../../../components/Elements/TextStyles/TextStyles";

const GroupDetailForm = () => {
  const [enableEdit, setEnableEdit] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [popupData, setPopupData] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { groupId: groupIdFromParams } = useParams();
  const dispatch = useDispatch();

  const groupIdFromState = location.state?.groupId ;
  const effectiveGroupId = groupIdFromParams || groupIdFromState;
 
  const { currentGroup, loading, error } = useSelector((state) => state.group);
  useEffect(() => {
    if (effectiveGroupId) {
      dispatch(fetchGroupById(effectiveGroupId));
    }
  }, [dispatch, effectiveGroupId]);

  const name = currentGroup?.groupName;
  const groupId = currentGroup?.groupId;
  const initial = currentGroup?.groupName
    ? currentGroup.groupName.substring(0, 2).toUpperCase()
    : "";

  const currentUserData = {
    _id: currentGroup?._id, // Required by your handleSave function
    groupName: currentGroup?.groupName || name, // groupName is used in the edit form
    name: name,
    email: currentGroup?.email || "",
    role: currentGroup?.role || "",
    address_1: currentGroup?.address_1 || "",
    address_2: currentGroup?.address_2 || "",
    city: currentGroup?.city || "",
    state: currentGroup?.state || "",
    pincode: currentGroup?.pincode || "",
    country: currentGroup?.country || "",
    description: currentGroup?.description || "",
  };

 if (loading && !currentGroup) {
  return <div className="p-10 text-center">Loading group details...</div>;
}

  // if (error) {
  //   return <div className="p-10 text-center text-red-500">Error: {error}</div>;
  // }

  return (
    <div
      style={{ paddingLeft: "40px", paddingRight: "40px" }}
    >

      {/* Breadcrumb Section */}
      <div className="flex justify-end mb-8 text-[12px] font-medium text-[#4B5563]">
        <span>Home / Group / <span className="text-[#54AEC2]">{name}</span></span>
      </div>

      {/* Main Form Title & Back Button */}

      <div className="flex items-center gap-3 mb-6">
        <div className="flex my-auto ">
          <BackIcon
            onClick={() => {
              const from = location.state?.from || "/group";
                    navigate(from);
            }}
          />

        </div>
        <h1 className="text-[18px] font-bold text-[#06513D] uppercase tracking-wide">{name}</h1>
      </div>

      {/* Detail Card Container */}
      <div className="border border-[#06513D] rounded-[10px] pt-[20px] shadow-[0px_0px_16px_0px_#3BA2B91F]  px-8 py-8 bg-white/70  relative">

        {/* Top Header Section inside card */}
        <div className="flex justify-between items-start mb-12">
          <div className="flex gap-4 items-center">
            {/* Initials Square */}
            <div className="w-[42px] h-[42px] rounded-[8px] border border-[#06513D] flex items-center justify-center text-[#06513D] text-[16px] font-bold bg-[#EBF5F6]/40">
              {initial}
            </div>

            <div className="flex flex-col justify-center">
              <div className="font-bold text-[16px] leading-tight text-black">
                {name}
              </div>
              <div className="font-normal text-[14px] leading-tight text-[#4B5563] mt-1">
                {groupId}
              </div>
            </div>
          </div>


          <div className="relative"  onClick={() => {
                  setSelectedUser(currentUserData);
                  setOpenEditDialog(true);
                }}>
            <div className="w-20 h-10 flex items-center justify-center   rounded-[8px] border border-[#06513D] text-gray-800 bg-transparent text-[15px] ">
              <EditIcon
                style={{ fontSize: "18px", cursor: "pointer" }}
               
              />
              Edit
            </div>
          </div>
        </div>

        {/* Address details */}
        <div className="px-5 mb-11">
          <h4 className="text-[14px] font-semibold text-[#6B7280] mb-6">
            Address details
          </h4>

          <div className="grid grid-cols-3 gap-x-12 gap-y-10">
            {/* Address 1 */}
            <div className="relative">
              <input
                type="text"
                name="address1"
                placeholder="Address 1"
                value={currentGroup?.
                  address_1 || ""}
                readOnly
                className="w-full pb-1 border-b border-[#D1D5DB] text-gray-800 placeholder-[#9CA3AF] focus:outline-none focus:border-[#06513D] bg-transparent text-[15px]"
                disabled={!enableEdit}
              />
            </div>

            {/* Address 2 */}
            <div className="relative">
              <input
                type="text"
                name="address2"
                placeholder="Address 2"
                value={currentGroup?.
                  address_2 || ""}
                readOnly
                className="w-full pb-1 border-b border-[#D1D5DB] text-gray-800 placeholder-[#9CA3AF] focus:outline-none focus:border-[#06513D] bg-transparent text-[15px]"
                disabled={!enableEdit}
              />
            </div>

            {/* City */}
            <div className="relative">
              <input
                type="text"
                name="city"
                placeholder="City"
                value={currentGroup?.city || ""}
                readOnly
                className="w-full pb-1 border-b border-[#D1D5DB] text-gray-800 placeholder-[#9CA3AF] focus:outline-none focus:border-[#06513D] bg-transparent text-[15px]"
                disabled={!enableEdit}
              />
            </div>

            {/* State */}
            <div className="relative">
              <input
                type="text"
                name="state"
                placeholder="State"
                value={currentGroup?.state || ""}
                readOnly
                className="w-full pb-1 border-b border-[#D1D5DB] text-gray-800 placeholder-[#9CA3AF] focus:outline-none focus:border-[#06513D] bg-transparent text-[15px] pr-6"
                disabled={!enableEdit}
              />
              <div className="absolute right-1 top-2.5 text-[#9CA3AF] pointer-events-none">
                <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 0.5L4 5.5L8 0.5H0Z" fill="currentColor" />
                </svg>
              </div>
            </div>

            {/* Pincode */}
            <div className="relative">
              <input
                type="text"
                name="pincode"
                placeholder="Pincode"
                value={currentGroup?.pincode || ""}
                readOnly
                className="w-full pb-1 border-b border-[#D1D5DB] text-gray-800 placeholder-[#9CA3AF] focus:outline-none focus:border-[#06513D] bg-transparent text-[15px]"
                disabled={!enableEdit}
              />
            </div>

            {/* Country */}
            <div className="relative">
              <input
                type="text"
                name="country"
                placeholder="Country"
                value={currentGroup?.country || ""}
                readOnly
                className="w-full pb-1 border-b border-[#D1D5DB] text-gray-800 placeholder-[#9CA3AF] focus:outline-none focus:border-[#06513D] bg-transparent text-[15px]"
                disabled={!enableEdit}
              />
            </div>

          </div>
        </div>

        {/* Description section */}
        <div className="px-5">
          <h4 className="text-[15px] font-semibold text-[#374151] mb-2">
            Description
          </h4>
          <textarea
            className="w-full h-32 border border-[#E5E7EB] rounded-2xl p-4 resize-none focus:outline-none focus:border-[#06513D] bg-transparent text-[15px] shadow-sm"
            disabled={!enableEdit}
            value={currentGroup?.description || ""}
            readOnly
          ></textarea>
        </div>

      </div>


      {openEditDialog && selectedUser && (
        <EditDetailForm
          onOpen={openEditDialog}
          onClose={() => {
            setOpenEditDialog(false);
            setSelectedUser(null); // Clean up state on close
          }}
          userData={selectedUser}
          onSave={() => {
            setPopupData({
              visible: true,
              type: "success",
              title: "User Edited",
              message: "User Edited Successfully",
            });

            if (groupIdFromState) {
              dispatch(fetchGroupById(groupIdFromState));
            }
            setOpenEditDialog(false);

            setTimeout(() => {
              setPopupData(null);
            }, 2000);
          }}
          onSuccessFalse={(msg) =>
            setPopupData({
              visible: true,
              type: "error",
              title: "Failed",
              message: msg || "Failed to edit User",
            })
          }
        />
      )}

      {popupData && (
        <div className="fixed inset-0 bg-black/30 z-50 flex items-center justify-center">
          <PopupCard
            type={popupData.type}
            title={popupData.title}
            message={popupData.message}
          />
        </div>
      )}

    </div>
  );
};

export default GroupDetailForm;